import React from 'react';
import { useGetPacksQuery, useLogUserActionMutation } from '../../../api/packSlice';
import LoadingIndicator from '../../LoadingIndicator';
import PackListEntry from './PackListEntry';
import { Stack, Grid, Typography, Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import PackReviewHeader from './PackReviewHeader';
import { useParams } from 'react-router-dom';

function PackList() {
    const location = useLocation();
    const physicianId = Number(useParams().physicianId);
    const campaignId = location.state?.campaignId ? Number(location.state.campaignId) : null;
    const navigate = useNavigate();
    const { data: packs = [], isLoading, isSuccess } = useGetPacksQuery(physicianId);
    const [submitUserAction] = useLogUserActionMutation();

    // Sort Packs by status
    const sortedPacks = [...packs].sort((a, b) => {
        const statusOrder = ['in-progress', 'open', 'submitted'];
        return statusOrder.indexOf(a.pack_status) - statusOrder.indexOf(b.pack_status);
    });

    const navigateToDashboard = async () => {
        // Log navigation to dashboard
        submitUserAction({
            action: 'exiting_from_packs_to_dashboard',
            data: { physicianId, campaignId }
        }).unwrap().catch(err => console.error('Failed to log user action:', err));

        if (campaignId) {
            navigate(`/physicianDashboard/headline/${campaignId}`);
        } else {
            navigate('/physician/dashboard/landing');
        }
    };

    return (
        <Grid container sx={{ minHeight: '100vh', backgroundColor: '#F5F5F5' }}>
            <Grid item md={3} />
            <Grid item xs={12} md={6}>
                <PackReviewHeader title="Surgical Pack Optimization" backText="Dashboard" onClickBack={navigateToDashboard} />
                <Box sx={{ px: 2, pt: 3 }}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="heavy" sx={{ fontSize: 16 }}>
                            Review Pack Contents
                        </Typography>
                    </Stack>
                </Box>
                {/* Pack List */}
                <Stack spacing={2} padding={2}>
                    {isLoading && (
                        <LoadingIndicator />
                    )}
                    {isSuccess && packs.length === 0 && (
                        <Stack width="100%" height="300px" justifyContent="center" alignItems="center" spacing={2} pt={5}>
                            <Typography variant="h5" sx={{ fontWeight: 500 }}>No Packs Available</Typography>
                        </Stack>
                    )}
                    {isSuccess && packs.length > 0 && (
                        <Stack spacing={2}>
                            {sortedPacks.map((pack) => (
                                <PackListEntry key={pack.id} pack={pack} physicianId={physicianId} campaignId={campaignId} />
                            ))}
                        </Stack>
                    )}
                </Stack>
            </Grid>
        </Grid>
    );
}

export default PackList;